angular.module('festzelt-os.modules.wallets', [
    'ui.router',
    'festzelt-os.components',
    'festzelt-os.modules.wallets.templates'
]);

require('./routes');

require('./templates/module');



// WEBPACK FOOTER //
// ./src/app/modules/wallets/module.js